import { render } from "./selectMenuTreeSingleClone.vue?vue&type=template&id=774dd8ac"
import script from "./selectMenuTreeSingleClone.vue?vue&type=script&lang=js"
export * from "./selectMenuTreeSingleClone.vue?vue&type=script&lang=js"

import exportComponent from "/home/pages/train-manage/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__